var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-container"},[_c('div',{staticClass:"app-container_router"},[_c('router-view')],1),(_vm.isTabbar)?_c('tool-tabbar'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }